import { useNavigate } from '@ksyos/router';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ManagerAuthorization } from '@common/enums';
import { hasOneAuthorization } from '@frontend/utils';
import type { IReduxState } from '../configureStore';
import { DisplayFullName } from './elements/DisplayFullName';

export function AdminHomepage() {
    const { nameGiven, nameInfix, nameFamily } = useSelector((state: IReduxState) => state.authentication);
    const navigate = useNavigate();

    useEffect(() => {
        if (hasOneAuthorization(ManagerAuthorization.adminProcessRead)) {
            navigate('/processes');
        } else {
            navigate('/home');
        }
    }, []);

    return (
        <div>
            <div>
                <header
                    className="ph10"
                    id="topbar"
                >
                    <div className="topbar-left">
                        <ol className="breadcrumb pt5">
                            <li className="crumb-active fs16">
                                <span className="fa fa-home pr10 fs18"></span>
                            </li>
                        </ol>
                    </div>
                </header>

                <section
                    className="table-layout animated fadeIn"
                    id="content"
                >
                    <div className="tray tray-center">
                        <div
                            className="admin-form theme-primary mw800 center-block"
                            style={{ paddingBottom: '175px' }}
                        >
                            <div className="panel heading-border">
                                <div className="panel-header">
                                    <div className="p25">
                                        <h2 className="fw200">
                                            Welcome in ClientSafe{' '}
                                            <DisplayFullName
                                                nameFamily={nameFamily}
                                                nameGiven={nameGiven}
                                                nameInfix={nameInfix}
                                            />{' '}
                                        </h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}
